module.exports = __webpack_public_path__ + "static/media/ImgMBTI_RPIA.d3052af7.png";